import { LogLevel } from "@azure/msal-browser";
import { config } from "./utils/config";

const waitForRuntimeConfig = () => {
    return new Promise((resolve) => {
        if (window.runtimeConfig) {
            resolve();
        } else {
            const checkInterval = setInterval(() => {
                if (window.runtimeConfig) {
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);

            // Timeout de seguridad después de 10 segundos
            setTimeout(() => {
                clearInterval(checkInterval);
                resolve();
            }, 10000);
        }
    });
};

// Esperar a que runtimeConfig esté disponible antes de continuar
await waitForRuntimeConfig();

export const msalConfig = {
    auth: {
        clientId: config.MSAL_CLIENT_ID,
        authority: config.MSAL_AUTHORITY,
        redirectUri: '/', 
        postLogoutRedirectUri: '/', 
        navigateToLoginRequestUrl: false, 
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, 
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    // case LogLevel.Info:
                    //     console.info(message);
                    //     return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const getLoginRequest = () => {
    const apimClientId = config.APIM_CLIENT_ID;
    const baseScopes = [];
    
    if (apimClientId && apimClientId !== '') {
        baseScopes.push(`api://${apimClientId}/access_as_user`);
    }
    
    return {
        scopes: baseScopes
    };
};

// Para compatibilidad con código existente
export const loginRequest = {
    scopes: ["user.read"]
};

